import * as $ from 'jquery';
import { IEventAggregator, EventAggregator, IDisposable, serialDisposable } from 'common/barrels/core';
import { camel } from 'common/functions/string';
import { dateTimeTransmissionFormat } from 'common/functions/date';

import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { ValidationControl } from 'runtime/controls/validationcontrol';
import { WorkTrayView } from 'runtime/data/worktrayview';
import { ColumnTitlesByName, ViewResultType } from 'runtime/screens/viewscreen';
import { IViewModelRoot } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { LookupItem } from 'runtime/data/lookupitem';
import { WorkTrayColumn } from 'runtime/data/worktraycolumn';
import { ICondition, Condition, ConditionOfTimeSpan } from 'runtime/data/condition';
import { ViewSaveRequested } from 'runtime/events/viewsaverequested';

import { ValidationSummary } from 'shared/data/validation';
import { IResourceProvider } from 'common/resourceprovider';
import { Set } from 'immutable';

import * as ko from 'knockout';
import { Computed as KnockoutComputed, Observable as KnockoutObservable, ObservableArray as KnockoutObservableArray, observableArray as koObservableArray, computed as koComputed, observable as koObservable } from 'knockout';
import * as komapping from 'knockout.mapping';

import { move } from 'common/functions/array';

export class ViewEditDialog implements IDialog {
    options: IDialogOptions;
    private vm: ViewViewModel;
    private dialogContent: JQuery;

    private validationControl: ValidationControl;

    private addedNoSelect: boolean;

    private validationSummaryDisposable = serialDisposable(null);

    constructor(eventAggregator: IEventAggregator, workTrayView: WorkTrayView, isNew: boolean, private resources: IResourceProvider, columnTitlesByName: ColumnTitlesByName, closeAction: () => void, isReadOnly: boolean = false) {
        var vm = this.vm = new ViewViewModel(this, eventAggregator, workTrayView, isNew, resources, columnTitlesByName, x => this.validationFailed(x), isReadOnly);
        this.dialogContent = this.buildViewEditContent(resources);

        this.options = {
            title: '',
            width: 560,
            height: 412,
            dialogClass: 'wf-container wf-view-dialog',
            buttons: isReadOnly
                ? [ { text: resources.getCoreString('XamlClose'), click: () => this.close() } ]
                : [ { text: resources.getCoreString('XamlSave'), click: vm.save.bind(vm) } ],
            create: (/*event: Event, ui: Object*/) => {
                $('.wf-view-tabs', this.dialogContent).tabs();
                this.addedNoSelect = !$('body').hasClass('noselect');
                $('body').addClass('noselect');

                var $dialogParent = this.dialogContent.parent();

                var $buttonSet = $('.ui-dialog-buttonset', $dialogParent).css('float', 'none');

                $buttonSet.append(this.viewName(resources));

                if (!isReadOnly) {
                    var $saveButton = $('> button', $buttonSet).addClass('wf-view-save');
                    $saveButton.button('disable');
                    vm.hasChanges.subscribe(newValue => $saveButton.button(newValue ? 'enable' : 'disable'));
                } else {
                    var $closeButton = $('> button', $buttonSet).addClass('wf-view-close');
                    $closeButton.button();
                }
            },
            open: () => {
                var $dialogParent = this.dialogContent.parent();
                ko.applyBindings(vm, $dialogParent[0]);
                // IE8: set the default tab back to the first after requiring the "Filters" tab be displayed on create for the inputs to display text middle
                $('.wf-view-tabs', this.dialogContent).tabs('option', { active: 0 });
            },
            close: () => {
                if (this.addedNoSelect) {
                    $('body').removeClass('noselect');
                }
                if (closeAction !== undefined && closeAction !== null) {
                    closeAction();
                }
            }
        };
    }

    content(): JQuery {
        return this.dialogContent;
    }

    close(): void {
        this.dialogContent.dialog('close');
    }

    validationFailed(validationSummary: ValidationSummary): void {
        var $tabs = this.dialogContent.children().first();

        if (this.validationControl === undefined || this.validationControl === null) {
            $tabs.find('.ui-tabs-nav').append($('<li />').append($('<a />').attr('href', '#wf-view-dialog-5').text(this.resources.getCoreString('XamlValidation'))));

            var $tab = $('<div />').attr('id', 'wf-view-dialog-5').appendTo($tabs);

            var $div = $('<div />').addClass('wf-view-dialog-5-inner').appendTo($tab);

            var args = ControlArgs.createMock($div, { elementName: 'wfvieweditdialogvalidation' }, new EventAggregator(), null, this.resources);

            this.validationControl = new ValidationControl(args);

            $tabs.tabs('refresh');
        }

        this.validationControl.validationSummary = validationSummary;
        this.validationControl.render();

        $tabs.tabs('option', 'active', 5);
    }

    private viewName(resources: IResourceProvider): JQuery {
        return $('<div />').addClass('wf-view-name').append([
            $('<label />').text(resources.getCoreString('XamlViewName')),
            $('<div />').append([
                $('<div />').attr('data-bind', 'textBox: { value: name }, disabled: $root.readonly')
            ])
        ]);
    }

    private buildViewEditContent(resources: IResourceProvider): JQuery {
        var navigation = $('<ul />').append([
            $('<li />').append($('<a />').attr('href', '#wf-view-dialog-1').text(resources.getCoreString('XamlOrderAndVisibility'))),
            $('<li />').append($('<a />').attr('href', '#wf-view-dialog-2').text(resources.getCoreString('XamlSorting'))),
            $('<li />').append($('<a />').attr('href', '#wf-view-dialog-3').text(resources.getCoreString('XamlFiltering'))),
            $('<li />').append($('<a />').attr('href', '#wf-view-dialog-4').text(resources.getCoreString('XamlOptions'))),
            $('<li />').append($('<a />').attr('href', '#wf-view-dialog-6').text(resources.getCoreString('XamlAttributeTitles')))
        ]);

        var tabVisibility = $('<div />').attr('id', 'wf-view-dialog-1').append([
            $('<div />').addClass('wf-view-dialog-1-inner').append([
                $('<div />').addClass('wf-view-dialog-1-left').append(
                    $('<fieldset />').append([
                        $('<legend />').text(resources.getCoreString('XamlVisibleColumns')),
                        $('<div />').css('float', 'right').append([
                            $('<button />').addClass('wf-view-column-order-up').attr('data-bind', 'enable: canSelectedVisibleMoveUp, click: moveSelectedVisibleUp').append($('<i />').addClass('fa fa-angle-up')),
                            $('<button />').addClass('wf-view-column-order-down').attr('data-bind', 'enable: canSelectedVisibleMoveDown, click: moveSelectedVisibleDown').append($('<i />').addClass('fa fa-angle-down'))
                        ]),
                        $('<div />').addClass('wf-view-dialog-1-content').append(
                            $('<ul />').attr('data-bind', 'foreach: visibleColumns').append(
                                $('<li />').attr('data-bind', 'text: $root.getCoreNameString(name()), click: $parent.setSelectedVisible.bind($parent), css: { \'wf-view-dialog-1-content-body-selected\': $parent.selectedVisibleColumns.indexOf($data) >= 0 }')
                            )
                        )
                    ])
                ),
                $('<div />').addClass('wf-view-dialog-1-right').append(
                    $('<fieldset />').append([
                        $('<legend />').text(resources.getCoreString('XamlAvailableColumns')),
                        $('<div />').addClass('wf-view-dialog-1-content').append(
                            $('<ul />').attr('data-bind', 'foreach: availableColumns').append(
                                $('<li />').attr('data-bind', 'text: $root.getCoreNameString(name()), click: $parent.setSelectedAvailable.bind($parent), css: { \'wf-view-dialog-1-content-body-selected\': $parent.selectedAvailableColumns.indexOf($data) >= 0 }')
                            )
                        )
                    ])
                ),
                $('<div />').addClass('wf-view-dialog-1-center').append([
                    $('<button />').addClass('wf-view-column-available').attr('data-bind', 'enable: hasSelectedVisible, click: makeSelectedAvailable').append($('<i />').addClass('fa fa-angle-right')),
                    $('<button />').addClass('wf-view-columns-available').attr('data-bind', 'click: makeAllAvailable, disable: $root.readonly').append($('<i />').addClass('fa fa-angle-double-right')),
                    $('<button />').addClass('wf-view-column-visible').attr('data-bind', 'enable: hasSelectedAvailable, click: makeSelectedVisible').append($('<i />').addClass('fa fa-angle-left')).css('margin-top', '100px'),
                    $('<button />').addClass('wf-view-columns-visible').attr('data-bind', 'click: makeAllVisible, disable: $root.readonly').append($('<i />').addClass('fa fa-angle-double-left'))
                ])
            ])
        ]);

        var tabSorting = $('<div />').attr('id', 'wf-view-dialog-2').append([
            $('<div />').addClass('wf-view-dialog-2-inner').append([
                $('<fieldset />').append([
                    $('<legend />').text(resources.getCoreString('XamlColumnsSortingOrder')),
                    $('<div />').css('float', 'right').append([
                        $('<div />').append($('<button />').attr('data-bind', 'enable: canMoveSelectedSortableUp, click: moveSelectedSortableUp').append($('<i />').addClass('fa fa-angle-up'))),
                        $('<div />').append($('<button />').attr('data-bind', 'enable: canMoveSelectedSortableDown, click: moveSelectedSortableDown').append($('<i />').addClass('fa fa-angle-down')))
                    ]),
                    $('<div />').addClass('wf-view-dialog-2-content').append([
                        $('<div />').addClass('wf-view-dialog-2-content-body').attr('data-bind', 'foreach: sortableColumns').append([
                            $('<div />').attr('data-bind', 'click: $parent.setSelectedSortable.bind($parent), css: { \'wf-view-dialog-2-content-body-selected\': selectedSorting }').append([
                                $('<div />').addClass('wf-view-dialog-2-content-name').attr('data-bind', 'text: $root.getCoreNameString(name())'),
                                $('<div />').addClass('wf-view-dialog-2-content-isdescending').append(
                                    $('<label />').append([
                                        resources.getCoreString('XamlIsDescending'),
                                        $('<input />').attr('type', 'checkbox').attr('data-bind', 'click: function() { return true; }, clickBubble: false, checked: isDescendingSorting, disable: $root.readonly')
                                    ])
                                )
                            ])
                        ])
                    ])
                ])
            ])
        ]);
        
        var tabFiltering = $('<div />').attr('id', 'wf-view-dialog-3').append([
            $('<div />').addClass('wf-view-dialog-3-inner').append([
                $('<fieldset />').append([
                    $('<legend />').text(resources.getCoreString('XamlWorkItems')),
                    $('<div />').addClass('form-group wf-checkbox').append([
                        $('<label />').append([
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: includeAvailable, disable: $root.readonly'),
                            resources.getCoreString('XamlIncludeWorkItemsAvailableForClaim')
                        ])
                    ]),
                    $('<div />').addClass('form-group wf-checkbox').append([
                        $('<label />').append([
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: includeClaimedByCurrentUser, disable: $root.readonly'),
                            resources.getCoreString('XamlIncludeWorkItemsClaimedByMe')
                        ])
                    ]),
                    $('<div />').addClass('form-group wf-checkbox').append([
                        $('<label />').append([
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: includeClaimedByOtherUser, disable: $root.readonly'),
                            resources.getCoreString('XamlIncludeWorkItemsClaimedByOtherUsers')
                        ])
                    ])
                ]),
                $('<div />').attr('data-bind', 'foreach: filterableColumns').append([
                    document.createComment('ko if: (name() === "State")'),
                    $('<fieldset />').append([
                        $('<legend />').attr('data-bind', 'text: $root.getCoreNameString(name())'),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('WorkItemStateNew')),
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: customFilterConditions.created, disable: $root.readonly')
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('WorkItemStateAvailable')),
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: customFilterConditions.available, disable: $root.readonly')
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('WorkItemStateClaimed')),
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: customFilterConditions.claimed, disable: $root.readonly')
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('WorkItemStateComplete')),
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: customFilterConditions.complete, disable: $root.readonly')
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('WorkItemStateDiscarded')),
                            $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: customFilterConditions.discarded, disable: $root.readonly')
                        ])
                    ]),
                    document.createComment('/ko'),
                    document.createComment('ko if: (name() === "Priority")'),
                    $('<fieldset />').append([
                        $('<legend />').attr('data-bind', 'text: $root.getCoreNameString(name())'),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('XamlWithin')),
                            $('<div />').addClass('wf-view-within').append([
                                $('<div />').attr('data-bind', 'numericBox: { value: customFilterConditions.greaterThanOrEqual }, disabled: $root.readonly')
                            ]),
                            $('<div />').addClass('wf-view-within').append([
                                $('<div />').attr('data-bind', 'numericBox: { value: customFilterConditions.lessThanOrEqual }, disabled: $root.readonly')
                            ])
                        ])
                    ]),
                    document.createComment('/ko'),
                    document.createComment('ko if: (name() === "DueDate" || name() === "LastModifiedDate" || name() === "CreateDate")'),
                    $('<fieldset />').addClass('wf-view-filter-datetime').append([
                        $('<legend />').attr('data-bind', 'text: $root.getCoreNameString(name())'),
                        $('<div />').addClass('form-group wf-view-filter-datetime-range').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('XamlWithin')),
                            $('<div />').addClass('wf-view-datepicker').append([
                                $('<div />').attr('data-bind', 'dateTimePicker: { selectedDate: customFilterConditions.greaterThanOrEqual }, disabled: $root.readonly')
                            ]),
                            $('<div />').addClass('wf-view-datepicker').append([
                                $('<div />').attr('data-bind', 'dateTimePicker: { selectedDate: customFilterConditions.lessThanOrEqual }, disabled: $root.readonly')
                            ])
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('XamlOffsetFromNow')),
                            $('<div />').addClass('wf-view-offset-value').append([
                                $('<div />').attr('data-bind', 'numericBox: { value: customFilterConditions.offsetValue }, disabled: $root.readonly')
                            ]),
                            $('<div />').addClass('wf-view-offset-type').append([
                                $('<div />').attr('data-bind', 'dropDownList: { selectedValue: customFilterConditions.offsetType, context: \'offsetType\', lookupItems: $root.getOffsetTypes.bind($root), lookupItem: $root.getOffsetType.bind($root) }, disabled: $root.readonly')
                            ])
                        ])
                    ]),
                    document.createComment('/ko'),

                    document.createComment('ko ifnot: (name() === "State" || name() === "Priority" || name() === "DueDate" || name() === "LastModifiedDate" || name() === "CreateDate")'),
                    $('<fieldset />').append([
                        $('<legend />').attr('data-bind', 'text: $root.getCoreNameString(name())'),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('XamlStartsWith')),
                            $('<div />').addClass('wf-view-text').append([
                                $('<div />').attr('data-bind', 'textBox: { value: customFilterConditions.startsWith }, disabled: $root.readonly')
                            ])
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('XamlEndsWith')),
                            $('<div />').addClass('wf-view-text').append([
                                $('<div />').attr('data-bind', 'textBox: { value: customFilterConditions.endsWith }, disabled: $root.readonly')
                            ])
                        ]),
                        $('<div />').addClass('form-group').append([
                            $('<label />').addClass('control-label').text(resources.getCoreString('XamlContains')),
                            $('<div />').addClass('wf-view-text').append([
                                $('<div />').attr('data-bind', 'textBox: { value: customFilterConditions.contains }, disabled: $root.readonly')
                            ])
                        ])
                    ]),
                    document.createComment('/ko')
                ])
            ])
        ]);
        var tabOptions = $('<div />').attr('id', 'wf-view-dialog-4').append([
            $('<div />').addClass('wf-view-dialog-4-inner').append([
                $('<fieldset />').append([
                    $('<legend />').text(resources.getCoreString('XamlOptions')),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlDisplayActionMenu')),
                        $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: displayActionMenu, disable: $root.readonly')
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlDisplayHistoryExpander')),
                        $('<input />').attr('type', 'checkbox').attr('data-bind', 'checked: displayHistory, disable: $root.readonly')
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlViewDataVersionPreference')),
                        $('<div />').addClass('wf-view-preference').append([
                            $('<div />').attr('data-bind', 'dropDownList: { selectedValue: viewDataPreference, context: \'viewDataPreference\', lookupItems: getViewDataPreferences, lookupItem: getViewDataPreference }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlSelectAllPreference')),
                        $('<div />').addClass('wf-view-preference').append([
                            $('<div />').attr('data-bind', 'dropDownList: { selectedValue: selectAllPreference, context: \'selectAllPreference\', lookupItems: getSelectAllPreferences, lookupItem: getSelectAllPreference }, disabled: $root.readonly')
                        ])
                    ])
                ])
            ])
        ]);
        
        var tabAttributeTitles = $('<div />').attr('id', 'wf-view-dialog-6').append([
            $('<div />').addClass('wf-view-dialog-6-inner').append([
                $('<fieldset />').append([
                    $('<legend />').text(resources.getCoreString('XamlAttributeTitles')),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute1')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue1") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute2')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue2") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute3')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue3") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute4')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue4") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute5')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue5") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute6')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue6") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute7')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue7") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute8')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue8") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute9')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue9") }, disabled: $root.readonly')
                        ])
                    ]),
                    $('<div />').addClass('form-group').append([
                        $('<label />').addClass('control-label').text(resources.getCoreString('XamlAttribute10')),
                        $('<div />').addClass('wf-view-text').append([
                            $('<div />').attr('data-bind', 'textBox: { value: getAttributeDisplayName("AttributeValue10") }, disabled: $root.readonly')
                        ])
                    ])
                ])
            ])
        ]);

        var tabControl = $('<div />').addClass('wf-view-tabs').append([
            navigation,
            tabVisibility,
            tabSorting,
            tabFiltering,
            tabOptions,
            tabAttributeTitles
        ]);

        var $content = $('<div />').addClass('noselect').addClass('wf-container').append(tabControl);

        // IE8: initially set the "Filters" tab to active, so the inputs are rendered correctly for text middle
        tabControl.tabs({ active: 2 });

        return $content;
    }
}

class ViewViewModel implements IViewModelRoot {
    name: KnockoutObservable<string>;
    columns: KnockoutObservableArray<ViewColumnViewModel>;

    private originalViewData: KnockoutObservable<string>;
    private excludeProperties: string[];

    private offsetTypeOptions: LookupItem[];
    private viewDataPreferenceOptions: LookupItem[];
    private selectAllPreferenceOptions: LookupItem[];

    visibleColumns: KnockoutComputed<ViewColumnViewModel[]>;
    availableColumns: KnockoutComputed<ViewColumnViewModel[]>;
    sortableColumns: KnockoutComputed<ViewColumnViewModel[]>;
    filterableColumns: KnockoutComputed<ViewColumnViewModel[]>;

    selectedVisibleColumns = koObservableArray<ViewColumnViewModel>();
    selectedAvailableColumns = koObservableArray<ViewColumnViewModel>();

    hasSelectedVisible: KnockoutComputed<boolean>;
    canSelectedVisibleMoveUp: KnockoutComputed<boolean>;
    canSelectedVisibleMoveDown: KnockoutComputed<boolean>;
    hasSelectedAvailable: KnockoutComputed<boolean>;
    canMoveSelectedSortableUp: KnockoutComputed<boolean>;
    canMoveSelectedSortableDown: KnockoutComputed<boolean>;

    hasChanges: KnockoutComputed<boolean>;
    readonly: KnockoutComputed<boolean>;

    constructor(private parentDialog: ViewEditDialog, public eventAggregator: IEventAggregator, view: WorkTrayView, private isNew: boolean, public resources: IResourceProvider, private columnTitlesByName: ColumnTitlesByName, private validationFailed: (x: ValidationSummary) => void, private isReadOnly: boolean = false) {
        this.offsetTypeOptions = [
            { active: true, keyValue: 'days', displayValue: resources.getCoreString('LblDays'), parentKeyValue: null, properties: null },
            { active: true, keyValue: 'hours', displayValue: resources.getCoreString('LblHours'), parentKeyValue: null, properties: null },
            { active: true, keyValue: 'minutes', displayValue: resources.getCoreString('LblMinutes'), parentKeyValue: null, properties: null }
        ];
        this.viewDataPreferenceOptions = [
            { active: true, keyValue: 'prompt', displayValue: resources.getCoreString('LblPrompt'), parentKeyValue: null, properties: null },
            { active: true, keyValue: 'modified', displayValue: resources.getCoreString('LblModified'), parentKeyValue: null, properties: null },
            { active: true, keyValue: 'original', displayValue: resources.getCoreString('XamlOriginal'), parentKeyValue: null, properties: null }
        ];
        this.selectAllPreferenceOptions = [
            { active: true, keyValue: 'prompt', displayValue: resources.getCoreString('LblPrompt'), parentKeyValue: null, properties: null },
            { active: true, keyValue: 'allCurrentPage', displayValue: resources.getCoreString('LblCurrentPage'), parentKeyValue: null, properties: null },
            { active: true, keyValue: 'all', displayValue: resources.getCoreString('LblAllPages'), parentKeyValue: null, properties: null }
        ];

        this.excludeProperties = ['originalViewData'];
        for (var prop in this) {
            if (this.hasOwnProperty(prop)) {
                this.excludeProperties.push(prop);
            }
        }

        // Expose isReadOnly as a Knockout computed observable for bindings
        this.readonly = koComputed(() => this.isReadOnly);

        var createColumnViewModel = (column: WorkTrayColumn): ViewColumnViewModel => {
            var columnViewModel: any = komapping.fromJS(column, { 'ignore': ['filterConditions'] }, new ViewColumnViewModel());

            columnViewModel.customFilterConditions = ((column.name === 'State')
                ? new StateFilterConditionBase(column.filterConditions)
                : (column.name === 'Priority')
                    ? new WithInIntFilterConditionBase(column.filterConditions)
                    : (column.name === 'DueDate' || column.name === 'LastModifiedDate' || column.name === 'CreateDate')
                        ? new DateTimeFilterConditionBase(column.filterConditions)
                        : new StringFilterConditionBase(column.filterConditions));

            return columnViewModel;
        };
        var mappingOptions = {
            'columns': {
                key: (data: WorkTrayColumn): string => ko.utils.unwrapObservable(data.name),
                create: (options: { data: WorkTrayColumn; parent: WorkTrayView }): ViewColumnViewModel => createColumnViewModel(options.data)
            }
        };

        komapping.fromJS(view, mappingOptions, this);

        this.originalViewData = koObservable(JSON.stringify(this.getUnmappedView()));

        this.visibleColumns = koComputed(() => this.columns().filter(c => c.isVisible()).sort((a, b) => a.orderSequence() - b.orderSequence()));

        this.availableColumns = koComputed(() => this.columns().filter(c => !c.isVisible()));

        this.sortableColumns = koComputed(() => this.columns().filter(c => c.isSortable()).sort((a, b) => a.sortSequence() - b.sortSequence()));

        this.filterableColumns = koComputed(() => this.columns()
            .filter(c => c.isFilterable() && c.name() !== 'CreateUserDisplayName' && c.name() !== 'CreateDate')
            .map(c => ({
                item: c,
                sortKey: this.sortKey(c.name())
            }))
            .sort((a, b) => a.sortKey - b.sortKey)
            .map(x => x.item)
        );

        this.hasSelectedVisible = koComputed(() => !this.isReadOnly && this.selectedVisibleColumns().length > 0);
        this.canSelectedVisibleMoveUp = koComputed(() => {
            var cols = this.visibleColumns();
            var selectedCols = this.selectedVisibleColumns();
            return (!this.isReadOnly && selectedCols.length === 1 && cols.indexOf(selectedCols[0]) > 0);
        });
        this.canSelectedVisibleMoveDown = koComputed(() => {
            var cols = this.visibleColumns();
            var selectedCols = this.selectedVisibleColumns();
            return (!this.isReadOnly && selectedCols.length === 1 && cols.indexOf(selectedCols[0]) < (cols.length - 1));
        });

        this.hasSelectedAvailable = koComputed(() => !this.isReadOnly && this.selectedAvailableColumns().length > 0);

        this.canMoveSelectedSortableUp = koComputed(() => {
            var cols = this.sortableColumns();
            var selectedCol = cols.filter(c => c.selectedSorting())[0] || null;
            return (this.isReadOnly || selectedCol === null)
                ? false
                : cols.indexOf(selectedCol) > 0;
        });
        this.canMoveSelectedSortableDown = koComputed(() => {
            var cols = this.sortableColumns();
            var selectedCol = cols.filter(c => c.selectedSorting())[0] || null;
            return (this.isReadOnly || selectedCol === null)
                ? false
                : cols.indexOf(selectedCol) < (cols.length - 1);
        });

        this.hasChanges = koComputed(() => {
            var unmappedView = JSON.stringify(this.getUnmappedView());
            return !this.isReadOnly && this.originalViewData() !== unmappedView;
        });
    }

    private sortKey(columnName: string) {
        switch (columnName) {
            case 'Title':
                return 0;
            case 'DefinitionTitle':
                return 2;
            case 'StepTitle':
                return 1;
            case 'State':
                return 6;
            case 'ClaimUserDisplayName':
                return 7;
            case 'Priority':
                return 5;
            case 'DueDate':
                return 3;
            case 'LastModifiedDate':
                return 4;
            case 'AttributeValue1':
                return 8;
            case 'AttributeValue2':
                return 9;
            case 'AttributeValue3':
                return 10;
            case 'AttributeValue4':
                return 11;
            case 'AttributeValue5':
                return 12;
            case 'AttributeValue6':
                return 13;
            case 'AttributeValue7':
                return 14;
            case 'AttributeValue8':
                return 15;
            case 'AttributeValue9':
                return 16;
            case 'AttributeValue10':
                return 17;
            default:
                return 99;
        }
    }

    save(): void {
        var unmappedView = this.getUnmappedView();
        
        this.eventAggregator.publish(new ViewSaveRequested(unmappedView, this.isNew, () => this.parentDialog.close(), x => this.validationFailed(x)));
    }

    setSelectedVisible(col: ViewColumnViewModel, event: MouseEvent): void {
        if (event.shiftKey) {
            var cols = this.visibleColumns();
            var colIndex = cols.indexOf(col);
            var lastCol = this.selectedVisibleColumns.pop();
            var lastIndex = (lastCol !== undefined && lastCol !== null) ? cols.indexOf(lastCol) : colIndex;

            var colsToSelect = (lastIndex < colIndex)
                ? cols.slice(lastIndex, colIndex)
                : cols.slice(colIndex, lastIndex);

            this.selectedVisibleColumns(colsToSelect);
            return;
        }

        if (event.ctrlKey) {
            var rm = this.selectedVisibleColumns.remove(item => item.name === col.name);
            if (rm.length === 0) {
                this.selectedVisibleColumns.push(col);
            }
            return;
        }

        var selectedVisibleCount = this.selectedVisibleColumns().length;
        var selectedVisible = (this.selectedVisibleColumns.indexOf(col) >= 0);
        this.selectedVisibleColumns.removeAll();
        if (selectedVisibleCount > 0 || !selectedVisible) {
            this.selectedVisibleColumns.push(col);
        }
    }

    moveSelectedVisibleUp(): void {
        const visibleCols = this.visibleColumns();
        const selectedVisibleColArray = this.selectedVisibleColumns();

        if (selectedVisibleColArray.length !== 1)
            return;

        var selectedVisibleCols = selectedVisibleColArray;
        var col = Set(visibleCols).intersect(selectedVisibleCols).first();
        if (col === null)
            return;
        
        const colIndex = visibleCols.indexOf(col);

        move(visibleCols.sort((a, b) => a.orderSequence() - b.orderSequence()), colIndex, colIndex - 1).forEach((x, i) => {
            if (x.orderSequence() !== i)
                x.orderSequence(i);
        });
    }

    moveSelectedVisibleDown(): void {
        const visibleCols = this.visibleColumns();
        const selectedVisibleColumns = this.selectedVisibleColumns();

        if (selectedVisibleColumns.length !== 1)
            return;

        var selectedVisibleCols = selectedVisibleColumns;
        var col = Set(visibleCols).intersect(selectedVisibleCols).first();
        if (col === null)
            return;

        const colIndex = visibleCols.indexOf(col);

        move(visibleCols.sort((a, b) => a.orderSequence() - b.orderSequence()), colIndex, colIndex + 1).forEach((x, i) => {
            if (x.orderSequence() !== i)
                x.orderSequence(i);
        });
    }

    moveSelectedSortableUp(): void {
        const cols = this.sortableColumns();
        const col = cols.filter(c => c.selectedSorting())[0] || null;

        if (col === null)
            return;

        const colIndex = cols.indexOf(col);

        if (colIndex < 0)
            return;

        move(cols.sort((a, b) => a.sortSequence() - b.sortSequence()), colIndex, colIndex - 1).forEach((x, i) => {
            if (x.sortSequence() !== i)
                x.sortSequence(i);
        });
    }

    moveSelectedSortableDown(): void {
        const cols = this.sortableColumns();
        const col = cols.filter(c => c.selectedSorting())[0] || null;

        if (col === null)
            return;

        const colIndex = cols.indexOf(col);

        if (colIndex < 0)
            return;

        move(cols.sort((a, b) => a.sortSequence() - b.sortSequence()), colIndex, colIndex + 1).forEach((x, i) => {
            if (x.sortSequence() !== i)
                x.sortSequence(i);
        });
    }

    setSelectedAvailable(col: ViewColumnViewModel, event: MouseEvent): void {
        if (event.shiftKey) {
            var cols = this.availableColumns();
            var colIndex = cols.indexOf(col);
            var lastCol = this.selectedAvailableColumns.pop();
            var lastIndex = (lastCol !== undefined && lastCol !== null) ? cols.indexOf(lastCol) : colIndex;

            var colsToSelect = (lastIndex < colIndex)
                ? cols.slice(lastIndex, colIndex)
                : cols.slice(colIndex, lastIndex);

            this.selectedAvailableColumns(colsToSelect);
            return;
        }

        if (event.ctrlKey) {
            var rm = this.selectedAvailableColumns.remove(item => item.name === col.name);
            if (rm.length === 0) {
                this.selectedAvailableColumns.push(col);
            }
            return;
        }

        var selectedAvailableCount = this.selectedAvailableColumns().length;
        var selectedAvailable = (this.selectedAvailableColumns.indexOf(col) >= 0);
        this.selectedAvailableColumns.removeAll();
        if (selectedAvailableCount > 0 || !selectedAvailable) {
            this.selectedAvailableColumns.push(col);
        }
    }

    private makeAvailable(visibleColumns: ViewColumnViewModel[]): void {
        visibleColumns.forEach(col => {
            var columns = this.visibleColumns();
            // get the index of the item before changing it's visibility
            var columnIndex = columns.indexOf(col);

            col.isVisible(false);

            columns.slice(columnIndex+1).forEach(colBelow => colBelow.orderSequence(colBelow.orderSequence() - 1));
        });

        this.selectedVisibleColumns.removeAll();
    }

    makeSelectedAvailable(): void {
        this.makeAvailable(this.selectedVisibleColumns());
    }

    makeAllAvailable(): void {
        this.makeAvailable(this.visibleColumns());
    }

    private makeVisible(availableColumns: ViewColumnViewModel[]): void {
        var lastVisibleColumn = this.visibleColumns().slice().sort((a, b) => b.orderSequence() - a.orderSequence())[0] || null;
        var orderSequence = (lastVisibleColumn !== undefined && lastVisibleColumn !== null ? lastVisibleColumn.orderSequence() + 1 : 0);

        availableColumns.forEach(col => {
            col.orderSequence(orderSequence++);
            col.isVisible(true);
        });

        this.selectedAvailableColumns.removeAll();
    }

    makeSelectedVisible(): void {
        this.makeVisible(this.selectedAvailableColumns());
    }

    makeAllVisible(): void {
        this.makeVisible(this.availableColumns());
    }

    setSelectedSortable(col: ViewColumnViewModel): void {
        if (!col.selectedSorting()) {
            this.sortableColumns().filter(c => c.selectedSorting()).forEach(c => c.selectedSorting(false));
            col.selectedSorting(true);
        }
    }

    getAttributeDisplayName(attributeName: string): KnockoutComputed<string> {
        return koComputed({
            read: () => {
                const column = ko.utils.arrayFirst(this.columns(), col => col.name() === attributeName);
                return column ? column.displayName() : '';
            },
            write: (value: string) => {
                const column = ko.utils.arrayFirst(this.columns(), col => col.name() === attributeName);
                if (column) {
                    column.displayName(value);
                }
            }
        });
    }

    getCoreString(part1: string): string {
        return this.resources.getCoreString(part1);
    }

    getCoreNameString(part1: string): string {
        return this.columnTitlesByName.getTitle(part1, ViewResultType.ViewSettings) || this.resources.getCoreString('XamlNotFound');
    }

    getOffsetTypes(): LookupItem[] {
        return this.offsetTypeOptions;
    }

    getOffsetType(keyValue: string): LookupItem {
        return this.offsetTypeOptions.filter(i => i.keyValue === keyValue)[0];
    }

    getViewDataPreferences(): LookupItem[] {
        return this.viewDataPreferenceOptions;
    }

    getViewDataPreference(keyValue: string): LookupItem {
        return this.viewDataPreferenceOptions.filter(i => i.keyValue === keyValue)[0];
    }

    getSelectAllPreferences(): LookupItem[] {
        return this.selectAllPreferenceOptions;
    }

    getSelectAllPreference(keyValue: string): LookupItem {
        return this.selectAllPreferenceOptions.filter(i => i.keyValue === keyValue)[0];
    }

    private getUnmappedView(): WorkTrayView {
        var unmappedView: any = komapping.toJS(this, { ignore: this.excludeProperties });

        var columns = this.columns();
        for (var i = 0; i < unmappedView.columns.length; i++) {
            unmappedView.columns[i].filterConditions = columns[i].customFilterConditions.getFilterConditions();
        }

        return unmappedView;
    }
}

class ViewColumnViewModel {
    name: KnockoutObservable<string>;
    displayName: KnockoutObservable<string>;
    isVisible: KnockoutObservable<boolean>;
    isSortable: KnockoutObservable<boolean>;
    sortSequence: KnockoutObservable<number>;
    orderSequence: KnockoutObservable<number>;
    isFilterable: KnockoutObservable<boolean>;
    isDescendingSorting: KnockoutObservable<boolean>;

    selectedSorting = koObservable(false);

    customFilterConditions: IConditionBase;
}

interface IConditionBase {
    getFilterConditions: () => ICondition[];
}

class StateFilterConditionBase implements IConditionBase {
    created = koObservable(false); // this is a synonym for the 'new' state to allow knockout binding in IE8
    available = koObservable(false);
    claimed = koObservable(false);
    complete = koObservable(false);
    discarded = koObservable(false);

    constructor(filterConditions: Condition[]) {
        filterConditions.reduce((p, c) => {
            c.value.reduce((sp, sc) => {
                switch (sc) {
                    case 'new':
                        sp.created(true);
                        break;
                    default:
                        sp[sc](true);
                        break;
                }
                return sp;
            }, p);
            return p;
        }, this);
    }

    getFilterConditions(): ICondition[] {
        var $type = 'Core.ConditionOfWorkItemStates';

        var conditions: ICondition[] = [];
        var t: string[] = [];

        for (var p in this) {
            if (this.hasOwnProperty(p) && p !== 'getFilterConditions') {
                var value = (<any>this[p])();
                if (value) {
                    t.push(p === 'created' ? 'new' : p);
                }
            }
        }

        conditions.push({ $type: $type, operation: 'equalsOneOf', value: t });

        return conditions;
    }
}

class WithInIntFilterConditionBase implements IConditionBase {
    greaterThanOrEqual = koObservable<number>(null);
    lessThanOrEqual = koObservable<number>(null);

    constructor(filterConditions: Condition[]) {
        filterConditions.reduce((p, c) => {
            var k = camel(c.operation);
            p[k](c.value);
            return p;
        }, this);
    }

    getFilterConditions(): ICondition[] {
        var $type = 'Core.ConditionOfInt';

        var conditions: ICondition[] = [];

        for (var p in this) {
            if (this.hasOwnProperty(p) && p !== 'getFilterConditions') {
                var value = (<any>this[p])();
                if (value) {
                    conditions.push({ $type: $type, operation: p, value: value });
                }
            }
        }

        return conditions;
    }
}

class DateTimeFilterConditionBase implements IConditionBase {
    private dateValueInFormat = dateTimeTransmissionFormat();

    greaterThanOrEqual = koObservable<string>(null);
    lessThanOrEqual = koObservable<string>(null);
    offsetType = koObservable<string>('days');
    offsetValue = koObservable(0);

    constructor(filterConditions: Condition[]) {
        filterConditions.forEach(c => {
            switch (c.operation) {
                case 'offsetFromNow':
                    if (c['valueAsOffset']) {
                        this.offsetType(c['valueAsOffset']['offsetType']);
                        this.offsetValue(c['valueAsOffset']['offsetValue']);
                    }
                    break;
                case 'greaterThanOrEqual':
                    if (c.value) {
                        this.greaterThanOrEqual(c.value);
                    }
                    break;
                case 'lessThanOrEqual':
                    if (c.value) {
                        this.lessThanOrEqual(c.value);
                    }
                    break;
            }
        });

        this.offsetValue.subscribe(newValue => {
            if (newValue < 0) {
                this.offsetValue(0);
            }
        });
    }

    getFilterConditions(): ICondition[] {
        var $type = 'Core.ConditionOfDateTime';
        var $type2 = 'Core.ConditionOfTimeSpan';

        var conditions: ICondition[] = [];

        if (this.greaterThanOrEqual()) {
            conditions.push({ $type: $type, operation: 'greaterThanOrEqual', value: this.greaterThanOrEqual() });
        }
        if (this.lessThanOrEqual()) {
            conditions.push({ $type: $type, operation: 'lessThanOrEqual', value: this.lessThanOrEqual() });
        }
        if (this.offsetValue() !== 0) {
            conditions.push(<ConditionOfTimeSpan>{ $type: $type2, operation: 'offsetFromNow', value: null, valueAsOffset: { offsetType: this.offsetType(), offsetValue: this.offsetValue() } });
        }

        return conditions;
    }
}

class StringFilterConditionBase implements IConditionBase {
    startsWith = koObservable<string>(null);
    endsWith = koObservable<string>(null);
    contains = koObservable<string>(null);

    constructor(filterConditions: Condition[]) {
        filterConditions.reduce((p, c) => {
            var k = camel(c.operation);
            p[k](c.value);
            return p;
        }, this);
    }

    getFilterConditions(): ICondition[] {
        var $type = 'Core.ConditionOfString';

        var conditions: ICondition[] = [];

        for (var p in this) {
            if (this.hasOwnProperty(p) && p !== 'getFilterConditions') {
                var value = (<any>this[p])();
                if (value) {
                    conditions.push({ $type: $type, operation: p, value: value });
                }
            }
        }

        return conditions;
    }
}